// File: src/components/common/StyledMediaImage.js
// -----------------------------------------------------
import React from 'react';
import { CardMedia } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Styled media image component with hover effects
 */
const StyledMediaImage = ({ image, alt, height = 160, ...props }) => (
  <CardMedia
    component="img"
    height={height}
    image={image}
    alt={alt}
    sx={{ 
      objectFit: 'cover',
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.08)'
      },
      ...props.sx
    }}
    {...props}
  />
);

StyledMediaImage.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.number,
  sx: PropTypes.object
};

export default StyledMediaImage;